import * as React from 'react';

import { useMaxLengthValidator } from 'shared/entities/common/hooks';
import { InputProps } from 'shared/newEntities/components/Input';

import Input from '../Input';

type Props = Omit<InputProps, 'maxLength' | 'ref'> & {
  maxLength: number;
};

const InputWithMaxLength: React.FC<Props> = ({
  maxLength,
  onBlur,
  error,
  ...rest
}) => {
  const { maxLengthValidatorProps, maxLengthError } = useMaxLengthValidator(
    maxLength,
    onBlur
  );

  const actualError = maxLengthError ?? error;

  return <Input {...rest} {...maxLengthValidatorProps} error={actualError} />;
};

export default React.memo(InputWithMaxLength);
